import {
  MfeSkeleton,
  SideBarSkeleton,
  TopBarSkeleton,
} from "@sinch/shell-skeleton";
import type { ReactNode } from "react";
import styled from "styled-components";
import { useLayoutConfig, type LayoutConfig } from "../hooks/useLayoutConfig";
import { mediaQueryMaxMedium } from "../mediaQuery";
import { zIndex } from "../portals/constants";
import {
  AppContainer,
  HeaderContainer,
  MainContainer,
} from "../portals/legacyEngage/engageComponents/MainElements";

const SidebarContainer = styled.aside`
  grid-area: aside;
  z-index: ${zIndex.overContentMenu}; /* Would prefer to go without but MFEs do stuff. */
  -ms-overflow-style: none;
  scrollbar-width: none;

  ::-webkit-scrollbar {
    display: none;
  }

  ${mediaQueryMaxMedium} {
    display: none;
  }
`;

type AppScaffoldProps = {
  children?: ReactNode;
  withSidebar?: boolean;
  withTopBar?: boolean;
  layoutConfig?: LayoutConfig;
};
export const TopBarLoading = () => (
  <HeaderContainer>
    <TopBarSkeleton />
  </HeaderContainer>
);

export const SideBarLoading = () => (
  <SidebarContainer>
    <SideBarSkeleton />
  </SidebarContainer>
);

export const MainContainerLoading = () => (
  <MainContainer>
    <MfeSkeleton />
  </MainContainer>
);

export const AppScaffold = ({
  withSidebar,
  withTopBar,
  layoutConfig = {
    topBar: { hideRoutes: [] },
    sidebar: { hideRoutes: [], mobileHideRoutes: [] },
    overlays: { hideRoutes: [] },
    skeleton: { hideRoutes: [] },
  },
}: AppScaffoldProps) => {
  const dynamicLayoutConfig = useLayoutConfig(layoutConfig);

  if (!dynamicLayoutConfig.skeleton) return null;

  return (
    <AppContainer>
      {withTopBar && dynamicLayoutConfig.topbar && <TopBarLoading />}
      <MainContainerLoading />
      {withSidebar && dynamicLayoutConfig.sidebar && <SideBarLoading />}
    </AppContainer>
  );
};

// eslint-disable-next-line no-restricted-syntax
export default AppScaffold;
